import { buildControllerRules } from "@gettactic/helpers/src/hook-form/buildControllerRules";
import { buildErrorMessageForName } from "@gettactic/helpers/src/hook-form/buildErrorMessageForName";
import React from "react";
import { Controller, FieldValues } from "react-hook-form";
import { ImageUploaderInput } from "./ImageUploaderInput";
import { HookFormImageUploaderInputProps } from "./ImageUploaderInput.types";

/**
 * @deprecated Use HookFormDropZoneUploadInput instead for a consistent upload experience
 */
export const HookFormImageUploaderInput = <T extends FieldValues>(
  props: HookFormImageUploaderInputProps<T>
): React.ReactElement => {
  const { form, name, rules, onChange, ...rest } = props;

  return (
    <Controller
      control={form.control}
      name={name}
      rules={buildControllerRules({
        form,
        name,
        rules,
        isRequired: props.isRequired
      })}
      render={({ field, fieldState }) => (
        <ImageUploaderInput
          {...rest}
          value={field.value}
          onChange={(file) => {
            field.onChange(file);
            onChange?.(file);
          }}
          error={
            fieldState.error?.message ||
            buildErrorMessageForName(form, name) ||
            undefined
          }
        />
      )}
    />
  );
};
